import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { locations } from '../data/locations';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const locationId = location.pathname.split('/')[1];
  const currentLocation = locations[locationId];

  const handleTitleClick = () => {
    if (currentLocation) {
      navigate('/');
    }
  };

  return (
    <div className="mb-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
        <div className="flex-grow">
          <h1 
            className={`text-3xl font-bold mb-2 text-green-800 ${
              currentLocation ? 'cursor-pointer hover:text-green-700 transition-colors duration-200' : ''
            }`}
            onClick={handleTitleClick}
            style={{ cursor: currentLocation ? 'pointer' : 'default' }}
          >
            {currentLocation ? `${currentLocation.name} Tree Health Dashboard` : 'Urban Tree Health Dashboard'}
          </h1>
          <div className="space-y-2">
            <p className="text-gray-600 text-lg">
              Monitoring urban forest health through real-time sap flow measurements
            </p>
            <p className="text-gray-600">
              This dashboard visualizes data from sap flow sensors installed across Chicago's universities. 
              These sensors measure the flow of sap in plants and provide valuable insights into plant health and water usage.
            </p>
          </div>
        </div>
        
        <div className="flex-shrink-0">
          <a 
            href="https://ictinternational.com/knowledge-base/tree-and-plant-water-use/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img 
              src="https://ictinternational.com/wp-content/uploads/2023/10/Sapflow-Gif.gif" 
              alt="Sap Flow Sensor" 
              className="w-40 h-auto object-contain rounded-lg"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Header;